var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundBreakup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 14.43C.138 10.87.8 5.776 4.28 3.05 7.76.329 12.74 1.006 15.403 4.567c2.662 3.56 1.999 8.654-1.48 11.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.493 11.403l-.065 4.651a.403.403 0 00.403.415l4.308-.031M6.631 5.901h5.215M6.631 8.09h5.215m-4.974 2.189l2.976 3.446M6.936 5.901h1.131c1.39 0 2.53.984 2.53 2.188 0 1.204-1.14 2.19-2.53 2.19h-1.13"
  }))));
}
export default SvgRefundBreakup;